import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "In this principle you can listen to four sets of pure tones that are accompanied by narrow band white noise (1080-1270 Hz). Each sound has the same amplitude. The first three pure tones are 900 Hz, the next three are 1000 Hz, the next set of three pure tones have a frequency of 1100 Hz, the last set of three pure tone beeps have a frequency of 1200 Hz. Notice how the 1100 Hz  and 1200 Hz tones are more masked  by the noise than the 900 Hz and 1000 Hz tones.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 7,
      rowsSize: [1, 2, 12, 5, 1, 2, 12],
      gap: 23,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/04/principle/divider.svg`,
                  viewType: "fill",
                },
              },
              styles: {
                width: "98%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "Only pure tones:",
                },
              },
              styles: {
                justifyContent: "flex-start",
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audio",
                options: {
                  src: `${config.ASSETS_URL}/02/04/principle/only-pure-tones.wav`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/04/principle/only-pure-tones-labels.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/04/principle/divider.svg`,
                  viewType: "fill",
                },
              },
              styles: {
                width: "98%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "Pure tones with noise:",
                },
              },
              styles: {
                justifyContent: "flex-start",
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audio",
                options: {
                  src: `${config.ASSETS_URL}/02/04/principle/pure-tone-with-noise.wav`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
